import api from '../../REST/api';
import { internalBillingTypes } from '../constants';

// eslint-disable-next-line import/prefer-default-export
export function isInternal(opportunity) {
  return internalBillingTypes
    .map(type => type.value)
    .includes(opportunity.billingType);
}

export const hasLowerCase = str => {
  return /[a-z]/.test(str);
};

export async function suggestionsCall(brands, businessModel) {
  const suggestions = await api.getSuggestedMerchantsAndSuppliers({
    data: { brandIds: brands, businessModel },
  });
  return suggestions;
}
